<template>
  <SignIn />
</template>

<script>
import SignIn from "../../components/Sign/SignIn.vue";
export default {
  name: "SignInPage",
  components: {
    SignIn,
  },
};
</script>

<style>
</style>